"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNotParentBindingConstraintsWithName = isNotParentBindingConstraintsWithName;
const isBindingConstraintsWithName_1 = require("./isBindingConstraintsWithName");
const isNotParentBindingConstraints_1 = require("./isNotParentBindingConstraints");
function isNotParentBindingConstraintsWithName(name) {
    return (0, isNotParentBindingConstraints_1.isNotParentBindingConstraints)((0, isBindingConstraintsWithName_1.isBindingConstraintsWithName)(name));
}
//# sourceMappingURL=isNotParentBindingConstraintsWithName.js.map